export default __webpack_public_path__ + "static/far-b2f66ab47e9d9fc3274ab7db73d8428d.png";